var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVpnStatusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.138,
    height: 13.166,
    viewBox: "0 0 24.138 13.166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "VPNStatusIcon",
    d: "M8.583,25.166a6.348,6.348,0,0,1-4.663-1.92A6.348,6.348,0,0,1,2,18.583,6.348,6.348,0,0,1,3.92,13.92,6.348,6.348,0,0,1,8.583,12,6.181,6.181,0,0,1,12.6,13.344a6.939,6.939,0,0,1,2.29,3.237h9.6a1.639,1.639,0,0,1,1.646,1.646v.713a1.639,1.639,0,0,1-1.646,1.646H23.23V23.52a1.639,1.639,0,0,1-1.646,1.646H21.42a1.639,1.639,0,0,1-1.646-1.646V20.585H14.892a6.939,6.939,0,0,1-2.29,3.237A6.181,6.181,0,0,1,8.583,25.166Zm0-4.718a1.865,1.865,0,1,0,0-3.73,1.865,1.865,0,1,0,0,3.73Z",
    transform: "translate(-2 -12)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpnStatusIcon);
export default __webpack_public_path__ + "static/media/VPNStatusIcon.948dac0a09f50880b9c414525842e943.svg";
export { ForwardRef as ReactComponent };